export default "__VITE_ASSET__M2tJi3dj__"